import { NavLink, Navigate, Outlet, useLocation } from 'react-router-dom';
import { BrandMark } from './Brand.js';
import { Icon } from './Icon.js';
import { adminApi } from '../lib/adminApi.js';
import {
  hasPlatformSession,
  getPlatformRefreshToken,
  getStoredPlatformAdmin,
  clearPlatformSession,
} from '../lib/platformSession.js';

// The super-admin console layout + the client-side guard. Reuses the exact tenant shell classes
// (.app / .side / .main) so the console is visually the same product — only the content differs.
//
// GUARD: with no PLATFORM session, every /admin/* route redirects to /admin/login. A tenant session
// (cc.* keys) grants NOTHING here — the guard reads only the platform keys, mirroring the backend's
// requirePlatformAdmin which rejects a tenant token. The two sessions are fully disjoint.

export function AdminShell(): JSX.Element {
  const location = useLocation();
  if (!hasPlatformSession()) {
    return <Navigate to="/admin/login" replace state={{ from: location.pathname }} />;
  }

  const admin = getStoredPlatformAdmin();

  async function logout(): Promise<void> {
    await adminApi.logout(getPlatformRefreshToken());
    clearPlatformSession();
    window.location.assign('/admin/login');
  }

  return (
    <div className="app" dir="rtl">
      <aside className="side">
        <div className="brand">
          <BrandMark />
          <div className="wm">Cross<b>Castr</b></div>
        </div>
        <div className="eyebrow" style={{ padding: '0 8px 14px' }}>קונסולת ניהול</div>
        <nav className="nav">
          <NavLink to="/admin/customers" className={({ isActive }) => (isActive ? 'active' : '')}>
            <Icon name="users" /> לקוחות
          </NavLink>
        </nav>
        <div className="side-foot">
          <div className="av">{(admin?.name ?? admin?.email ?? 'מנ').slice(0, 2)}</div>
          <div className="who">
            {admin?.name ?? admin?.email ?? 'מנהל-על'}<br />
            <small>מנהל פלטפורמה</small>
          </div>
          <button className="btn ghost" onClick={logout} title="התנתק" style={{ marginInlineStart: 'auto', padding: '6px 10px' }}>
            <Icon name="close" />
          </button>
        </div>
      </aside>
      <div className="main">
        <Outlet />
      </div>
    </div>
  );
}
